import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const StructureAlert = ({
  width = 16,
  height = 17,
  className,
  color,
  decorative = false,
  ariaLabel = "StructureAlert",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 16 17"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        strokeWidth="0.3"
        d="M14.61 15.15H1.555a.234.234 0 0 1-.235-.234v-1.428c0-.13.105-.234.235-.234H14.61c.129 0 .234.105.234.234v1.428c0 .13-.105.235-.234.235Zm-12.82-.468h12.585v-.96H1.79z"
      />
      <path
        strokeWidth="0.3"
        d="M13.135 13.723H3.039a.234.234 0 0 1-.234-.234V12.06c0-.129.105-.234.234-.234h10.096c.13 0 .234.105.234.234v1.429c0 .13-.105.234-.234.234Zm-9.862-.469h9.628v-.96H3.273z"
      />
      <path
        strokeWidth="0.3"
        d="M12.33 12.296H3.845a.234.234 0 0 1-.235-.235V7.366A4.45 4.45 0 0 1 4.921 4.2 4.46 4.46 0 0 1 8.087 2.89 4.45 4.45 0 0 1 11.253 4.2a4.46 4.46 0 0 1 1.312 3.166v4.695c0 .13-.105.235-.234.235Zm-8.252-.47h8.018v-4.46a4.014 4.014 0 0 0-4.009-4.009 4.014 4.014 0 0 0-4.009 4.01zM8.086 1.923a.234.234 0 0 1-.234-.234V.385a.234.234 0 1 1 .468 0v1.304c0 .13-.105.234-.234.234ZM4.32 3.51a.23.23 0 0 1-.165-.069l-.922-.922a.234.234 0 0 1 .331-.331l.922.922a.234.234 0 0 1-.165.4ZM2.538 7.291H1.234a.234.234 0 1 1 0-.469h1.304a.234.234 0 1 1 0 .469ZM14.992 7.227h-1.305a.234.234 0 0 1 0-.47h1.305a.234.234 0 1 1 0 .47ZM11.867 3.465a.234.234 0 0 1-.166-.4l.923-.922a.234.234 0 1 1 .331.331l-.922.922a.23.23 0 0 1-.166.07Z"
      />
      <path
        strokeWidth="0.3"
        d="M8.528 12.293h-.9a.234.234 0 0 1-.234-.234V9.466a1.22 1.22 0 0 1 .684-2.228 1.22 1.22 0 0 1 .685 2.228v2.593c0 .13-.105.234-.235.234Zm-.666-.468h.432V9.333c0-.088.049-.168.127-.209a.75.75 0 1 0-.686 0c.078.04.128.121.128.209z"
      />
    </svg>
  );
};
